import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { StudentMaster } from '../model/StudentMaster.model';
import { MainserviceService } from '../service/mainservice.service';

@Component({
  selector: 'app-my-referrals',
  templateUrl: './my-referrals.component.html',
  styleUrls: ['./my-referrals.component.scss']
})
export class MyReferralsComponent implements OnInit {
  studentMaster:StudentMaster = new StudentMaster();
  studentMasterSession:StudentMaster = new StudentMaster();
  studentMasterList:StudentMaster = new StudentMaster();
  totalRecords:number = 0;
  constructor(public mainService:MainserviceService) { }

  ngOnInit() {
    this.studentMasterSession= this.mainService.getstudentSession();
    this.getReferalList();
  }
  getReferalList(){
    this.studentMaster.referralCodeUsedInRegistration = this.studentMasterSession.referralCode;
    this.mainService.getStudentMasterList(this.studentMaster).subscribe(data=>{

      this.studentMasterList = data;
      this.getReferalListLength();
    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        //json circular break at server side always add
            //extra information of timestamp and status along with
            //main json so parsing occurs still at status 200
          
        
      }
    })
  }
  getReferalListLength(){
    this.studentMaster.referralCodeUsedInRegistration = this.studentMasterSession.referralCode;
    this.mainService.getStudentMasterListLength(this.studentMaster).subscribe(data=>{
      this.totalRecords = data;
    },(err: HttpErrorResponse)=>{
      if (err.status === 200) {
        //json circular break at server side always add
            //extra information of timestamp and status along with
            //main json so parsing occurs still at status 200
          
        
            
  
          //  this.redirection();
      }
    })
  }
}
